// extracted by mini-css-extract-plugin
module.exports = {"closeIcon":"CloseIcon_closeIcon__2VdAC"};